(function () {
  // Resize the YouTube background iframe so it always "covers" the hero container.
  function resizeHeroIframe(container) {
    var wrap = container.querySelector(".hero-block__video-wrap");
    if (!wrap) return;
    var iframe = wrap.querySelector("iframe");
    if (!iframe) return;

    // Use requestAnimationFrame to batch DOM reads/writes
    requestAnimationFrame(function () {
      var rect = wrap.getBoundingClientRect();
      // Subtract 160px (80px on each side) from the container width
      var cw = rect.width - 160;
      var ch = rect.height;
      var aspect = 16 / 9;

      // Calculate dimensions that will cover the container while preserving aspect ratio
      var requiredWidth = Math.max(cw, ch * aspect);
      var requiredHeight = Math.max(ch, cw / aspect);

      // Apply size and keep it centered via transform
      iframe.style.width = requiredWidth + "px";
      iframe.style.height = requiredHeight + "px";
      iframe.style.top = "50%";
      iframe.style.left = "50%";
      iframe.style.transform = "translate(-50%, -50%)";
      iframe.style.position = "absolute";
    });
  }

  function initAll() {
    var blocks = document.querySelectorAll(".hero-block.has-background-video");
    blocks.forEach(function (block) {
      // run once now
      resizeHeroIframe(block);
      // update on resize
      window.addEventListener("resize", function () {
        resizeHeroIframe(block);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      const content = toggle.nextElementSibling;
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !expanded);

      if (!expanded) {
        // Read before write to avoid forced reflow
        const height = content.scrollHeight;
        content.hidden = false;
        requestAnimationFrame(function () {
          content.style.height = height + "px";
        });
      } else {
        // Read height, then write in next frame
        const height = content.scrollHeight;
        content.style.height = height + "px";
        requestAnimationFrame(function () {
          content.style.height = "0";
        });
      }
    });

    // Transition end: hide content if collapsed
    const content = toggle.nextElementSibling;
    content.addEventListener("transitionend", function () {
      if (toggle.getAttribute("aria-expanded") === "false") {
        content.hidden = true;
      }
    });
  });

  // Case Studies Load More functionality
  const loadMoreBtn = document.getElementById("load-more-cases");
  const showLessBtn = document.getElementById("show-less-cases");

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const button = this;
      const currentPage = parseInt(button.getAttribute("data-page"));
      const maxPages = parseInt(button.getAttribute("data-max-pages"));
      const nextPage = currentPage + 1;

      // Show loading state
      button.textContent = "Loading...";
      button.disabled = true;

      // AJAX request with nonce for security
      const formData = new FormData();
      formData.append("action", "load_more_case_studies");
      formData.append("page", nextPage);
      formData.append("nonce", ajax_variable.case_studies_nonce);

      fetch(ajax_variable.ajax_url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // Append new content
            const grid = document.getElementById("case-studies-grid");
            grid.insertAdjacentHTML("beforeend", data.html);

            // Update button state
            button.setAttribute("data-page", nextPage);
            button.textContent = "Show More";
            button.disabled = false;

            // Hide "Show More" button and show "Show Less" button
            button.style.display = "none";
            if (showLessBtn) {
              showLessBtn.style.display = "flex";
            }
          } else {
            // Production: Silent fail or show user-friendly message
            button.textContent = "Show More";
            button.disabled = false;
          }
        })
        .catch((error) => {
          // Production: Silent fail or show user-friendly message
          button.textContent = "Show More";
          button.disabled = false;
        });
    });
  }

  if (showLessBtn) {
    showLessBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const grid = document.getElementById("case-studies-grid");
      const allCases = grid.querySelectorAll(".case-studies-archive__case");

      // Remove all cases after the first 6
      allCases.forEach((caseItem, index) => {
        if (index >= 6) {
          caseItem.remove();
        }
      });

      // Reset the page counter to 1
      if (loadMoreBtn) {
        loadMoreBtn.setAttribute("data-page", "1");
        loadMoreBtn.style.display = "flex";
      }

      // Hide the "Show Less" button
      showLessBtn.style.display = "none";

      // Scroll to the top of the grid
      grid.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const formContainer = document.querySelector(".roas-calculator__form");

  if (
    formContainer &&
    formContainer.querySelector(".gform_confirmation_wrapper")
  ) {
    formContainer.className = "roas-calculator__form confirmation";
  }
});

// Also listen for Gravity Forms AJAX submissions
jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
  const formContainer = document.querySelector(".roas-calculator__form");

  if (
    formContainer &&
    formContainer.querySelector(".gform_confirmation_wrapper")
  ) {
    formContainer.className = "roas-calculator__form confirmation";
  }
});
